import { orderBy, uniqueId } from 'lodash-es'
import { makeAutoObservable, observable } from 'mobx'
import React, { type CSSProperties } from 'react'

export type ModalOption = {
  type?: 'default' | 'full'
  hasCloseButton?: boolean
  onClose?: (...args: any[]) => boolean
  onAfterClose?: () => void
  dataAtribute?: Record<string, string>
  modalName: string
  headerOption?: {
    position?: 'center' | 'left' | 'right'
    hasBottomBorder?: boolean
    style?: CSSProperties
  }
  modalStyle?: {
    padding?: string
  }
  orderingNumber?: number
  isCloseable?: boolean
}

export type ModalContent = { header?: React.ReactNode; content: React.ReactNode }

class ModalState {
  private _id = uniqueId()
  modalContent: ModalContent
  opt: ModalOption & { orderingNumber: number }

  constructor(modalContent: ModalContent, opt: ModalOption) {
    this.modalContent = modalContent
    this.opt = {
      ...opt,
      orderingNumber: opt.orderingNumber ?? 50,
      isCloseable: opt.isCloseable ?? true,
    }
  }

  get id() {
    return this._id
  }
}

export class ModalService {
  private _modalList: ModalState[] = []
  isShowLoader = false

  get modalList() {
    return orderBy(this._modalList, 'opt.orderingNumber', 'desc')
  }

  constructor() {
    makeAutoObservable<this, '_modalList'>(this, {
      _modalList: observable,
    })
  }

  openModal = (modalContent: ModalContent | React.ReactNode, opt: ModalOption) => {
    window.freshpaint?.track('[공통] 모달 OPEN', { name: opt.modalName })

    if (React.isValidElement(modalContent)) {
      this._modalList.push(new ModalState({ content: modalContent }, opt))
    } else {
      this._modalList.push(new ModalState(modalContent as ModalContent, opt))
    }
  }

  closeModal = () => {
    if (this.modalList.length > 0) {
      const lastOrderedModalState = this.modalList[this.modalList.length - 1]
      this._modalList = this._modalList.filter((modalState) => {
        return modalState.id !== lastOrderedModalState?.id
      })

      if (lastOrderedModalState) {
        lastOrderedModalState.opt.onAfterClose?.()
      }
    }
  }

  closeAllModal = () => {
    this._modalList = []
  }

  showLoader = () => {
    this.isShowLoader = true
  }

  hideLoader = () => {
    this.isShowLoader = false
  }
}

const modalService = new ModalService()
export default modalService
